import { COLUMN_DAYS, COLUMN_DURATION, COLUMN_END_DATE, COLUMN_NAME, COLUMN_SITE, COLUMN_START_DATE, COLUMN_START_TIME } from "../../constants/column-types";
import { FILTER_DAYS, FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const DeviceTimePatternColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "tpName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Start Date",
        accessor: "startDate",
        isNumeric: false,
        id: 1,
        sortByName: "tpStartDate",
        sortDirection: "asc",
        active: true,
        translationKey: "startDate",
        columnId: COLUMN_START_DATE,
    },
    {
        heading: "End Date",
        accessor: "endDate",
        isNumeric: false,
        id: 2,
        sortByName: "tpEndDate",
        sortDirection: "asc",
        active: true,
        translationKey: "endDate",
        columnId: COLUMN_END_DATE,
    },
    {
        heading: "Days",
        accessor: "days",
        isNumeric: false,
        id: 3,
        active: true,
        searchOnName: "days", //This days is a placeholder so that we can get the search icon in the column heading
        lookupName: "days",
        translationKey: "days",
        columnId: COLUMN_DAYS,
        filterId: FILTER_DAYS
    },
    {
        heading: "Start Time",
        accessor: "startTime",
        isNumeric: false,
        id: 4,
        sortByName: "tpStartTime",
        sortDirection: "asc",
        active: true,
        translationKey: "startTime",
        columnId: COLUMN_START_TIME,
    },
    {
        heading: "Duration",
        accessor: "duration",
        isNumeric: false,
        id: 5,
        sortByName: "tpDuration",
        sortDirection: "asc",
        active: true,
        translationKey: "duration",
        columnId: COLUMN_DURATION,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 6,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    }
];

export default DeviceTimePatternColumns;
